export const LEADS_PERMISSION_ID = 'sponsor.scan_lead';
